function nothanks(){
  w2popup.close();
}

jQuery( document ).ready(function($){

 // var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
 // var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

 // if( isChrome )
 // {
 //   $('.selector-wrapper .select .single-option-selector').mouseover(function(){
 //     openselectopt($( "#productSelect-option-0" ))
 //   }).mouseleave(function(){
 //     $( "#productSelect-option-0" ).blur();
 //   });
 // }else if( isSafari ){
 //   $('.selector-wrapper .select .single-option-selector').mouseover(function(){
 //     openselectopt($( "#productSelect-option-0" ))
 //   });
 // }else{
 //   $('.selector-wrapper .select').hover(function(){
 //     openselectopt($( "#productSelect-option-0" ))
 //   });
 // }

 // function openselectopt(elem) {

 //     if (document.createEvent) {
 //         var e = document.createEvent("MouseEvents");
 //         e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
 //         elem[0].dispatchEvent(e);
 //     } else if (element.fireEvent) {
 //         elem[0].fireEvent("onmousedown");
 //     }
 // }

 w2popup.on('open', function(event) {
     console.log('event: ' + event.type, event);
 });

 $('.btn-closepop').on('click', function(){
     $('#popup2').hide();
     Cookies.set('hidepopup#x2', 'true', { expires: 365 });
 });

 if( !Cookies.get('hidepopup#x2') )
 {
   $('#popup2').delay('2000').show();
 }

 if( !Cookies.get('hidepopup#9') )
 {
   /*
   $('#popupmail').w2popup({
     modal : false,
     onOpen: function(event){
       //alert('before open')
     },
     onClose: function(event) {
       $('#popup2').show();
       Cookies.set('hidepopup#9', 'true', { expires: 365 });
     }
   });
   */

   /*
   $('#popup2').w2popup({
     transition : null,
     modal : true,
     onOpen: function(event){
       //alert('before open')
     },
     onClose: function(event) {
   //alert('xxx');
     }
   });
   */

 }else{
   if( !Cookies.get('hidepopup#x2') )
   {
     $('#popup2').delay('2000').show();
   }
 }

 $('.btn-vertical').on('click', function(){
   $('#popupmail').w2popup({
     modal : false,
     onClose: function(event) {
       $('#popup2').show();
     }
   });

   $('#popup2').hide();
 });

 $( "#shopify-product-reviews .spr-container .spr-header" ).appendTo( "#shopify-product-reviews-top .spr-container" );

 $("#productSlider").lightSlider({
       item:1,
       slideMargin:0,
       auto:false,
       loop:true,
       pauseOnHover: true,
       speed:1000,
       pause:5000,
       enableDrag: false
 });

 $('.hero-slider .list-slider').lightSlider({
   item:1,
   slideMargin:0,
   auto:true,
   loop:true,
   speed:1000,
   pause:2500,
   keyPress:false,
   enableDrag: true,
   boolean: false,
   controls: false
 });

 /* Slide image product */
 if ( $(window).width() <= 768 ) {
   var idG = '#' + $('.images-gallery > ul ').attr('id');
   $(idG).lightSlider({
     item: 1,
     loop: true,
     slideMargin: 1,
     auto:false,
     keyPress:false,
     enableDrag: false,
     boolean: false
   });

   $(idG).lightGallery({
     'download' : false
   });


   $('.lightSlider li').last().prev().addClass('slidervids');

   var ytvids = $('.slidervids > img').attr('alt');

   if( $(ytvids).hasClass('ytembed') ){

     $('.slidervids').html( ytvids );
     $('.ytembed')[0].play();

     $('.lSPager.lSGallery li').livequery( 'click', function() {
       if( typeof $(this).next().html() == 'undefined' ){
           $('.ytembed')[0].play();
       }
     });

     if ( $(window).width() < 640 ) {
         $( '.slidervids.active' ).livequery('click', function(){
               $('.lg-backdrop').remove();
               $('.lg-start-zoom').remove();
         });
     }
   }
 }
 /* End slide image product */

 /* Select size new */
 $('input[name="prosize"]').change(function() {
   $('#productSelect').val($(this).val());
 });

 /* Tab description coolection */
 var indexH5 = 1;
 $('.tab-discription > h5').each(function() {
   $(this).addClass('tab-' + indexH5);
   $('.tab-bar-description').append('<div class="wrapper-tab" id="titleTab' + indexH5 + '">' + $(this).text() + '</div>');
   $(this).hide();
   indexH5++;
 });

 for(i = 1 ; i < indexH5 ; i++) {
   j = i + 1;
   $('.tab-discription').append('<div id="tab' + i + '"></div>');
   $('.tab-discription > h5.tab-'+ i).nextUntil('.tab-discription > h5.tab-'+ j, 'p').appendTo('.tab-discription #tab' + i);
 }

 $('.tab-discription > h5').each(function() {
   $(this).remove();
 });

 $('.tab-bar-description .wrapper-tab:nth-child(1)').addClass('active');

 $('#titleTab1').click(function() {
   if(!$(this).hasClass('active')) {
     $('.tab-bar-description .wrapper-tab').each(function() {
       $(this).removeClass('active');
     });
     $(this).addClass('active');
   }
   $('.tab-discription > div').each(function() {
     $(this).hide();
   });
   $('#tab1').show();
 });
 $('#titleTab2').click(function() {
   if(!$(this).hasClass('active')) {
     $('.tab-bar-description .wrapper-tab').each(function() {
       $(this).removeClass('active');
     });
     $(this).addClass('active');
   }
   $('.tab-discription > div').each(function() {
     $(this).hide();
   });
   $('#tab2').show();
 });
 $('#titleTab3').click(function() {
   if(!$(this).hasClass('active')) {
     $('.tab-bar-description .wrapper-tab').each(function() {
       $(this).removeClass('active');
     });
     $(this).addClass('active');
   }
   $('.tab-discription > div').each(function() {
     $(this).hide();
   });
   $('#tab3').show();
 });


 /* Size chart */
 $('#whatSizeShirt').click(function() {
   $('.conatiner-size-chart').fadeIn();
   if(!$('#btn-shirt').hasClass('active')){
     $('#btn-shirt').addClass('active');
     $('#btn-t-shirt').removeClass('active');
     $('#btn-camisole').removeClass('active');
   }
   if(!$('#sizeChartShirt').hasClass('active')){
     $('#sizeChartShirt').addClass('active');
     $('#sizeChartTShirt').removeClass('active');
     $('#sizeChartCamisole').removeClass('active');
   }
 });

 $('#whatSizeTShirt').click(function() {
   $('.conatiner-size-chart').fadeIn();
   if(!$('#btn-t-shirt').hasClass('active')){
     $('#btn-t-shirt').addClass('active');
     $('#btn-shirt').removeClass('active');
     $('#btn-camisole').removeClass('active');
   }
   if(!$('#sizeChartTShirt').hasClass('active')){
     $('#sizeChartTShirt').addClass('active');
     $('#sizeChartShirt').removeClass('active');
     $('#sizeChartCamisole').removeClass('active');
   }
 });

 $('#whatSizeCamisole').click(function() {
   $('.conatiner-size-chart').fadeIn();
   if(!$('#btn-camisole').hasClass('active')){
     $('#btn-camisole').addClass('active');
     $('#btn-shirt').removeClass('active');
     $('#btn-t-shirt').removeClass('active');
   }
   if(!$('#whatSizeCamisole').hasClass('active')){
     $('#sizeChartCamisole').addClass('active');
     $('#sizeChartShirt').removeClass('active');
     $('#sizeChartTShirt').removeClass('active');
   }
 });

 $('#btn-shirt').click(function() {
   if(!$(this).hasClass('active')){
     $(this).addClass('active');
     $('#btn-t-shirt').removeClass('active');
     $('#btn-camisole').removeClass('active');
   }
   if(!$('#sizeChartShirt').hasClass('active')){
     $('#sizeChartShirt').addClass('active');
     $('#sizeChartTShirt').removeClass('active');
     $('#sizeChartCamisole').removeClass('active');
   }
 });

 $('#btn-t-shirt').click(function() {
   if(!$(this).hasClass('active')){
     $(this).addClass('active');
     $('#btn-shirt').removeClass('active');
     $('#btn-camisole').removeClass('active');
   }
   if(!$('#sizeChartTShirt').hasClass('active')){
     $('#sizeChartTShirt').addClass('active');
     $('#sizeChartShirt').removeClass('active');
     $('#sizeChartCamisole').removeClass('active');
   }
 });

 $('#btn-camisole').click(function() {
   if(!$(this).hasClass('active')){
     $(this).addClass('active');
     $('#btn-shirt').removeClass('active');
     $('#btn-t-shirt').removeClass('active');
   }
   if(!$('#sizeChartCamisole').hasClass('active')){
     $('#sizeChartCamisole').addClass('active');
     $('#sizeChartTShirt').removeClass('active');
     $('#sizeChartShirt').removeClass('active');
   }
 });

 $('.box-size-chart .close').click(function() {
   $('.conatiner-size-chart').fadeOut();
 });

 /* Slide image product page */
 if (jQuery(window).width() > 768) {
   if(jQuery('.template-product').length) {
     $(window).bind("load", function() {
     var heightNavMenu = $('#main-nav').outerHeight(true); //106px

       var el = $('#sticky');
       var stickyTop = $('#sticky').offset().top;
       var heightWindow = $(window).height();
       //Jquery Ten
       var infoTop = $('.info-pro').offset().top;
       var heightInfo = $('.info-pro').outerHeight(true);
       var heightTotal = heightInfo + infoTop + 20;
       var spaceTop = (heightInfo + infoTop + 20)- heightWindow;

       $(window).scroll(function() {
         var stickyHeight = $('#sticky').height();
         var limit = $('.content-review').offset().top - stickyHeight;
         var limit2 = $('.content-review').offset().top - $('.info-pro').height();
         var limitInfo = $('.content-review').offset().top - $('.info-pro').height() + (heightInfo + 20 - heightWindow);
         var windowTop = $(window).scrollTop();

         // Sidebar Left
         if ((stickyTop - heightNavMenu) < windowTop) {
           el.css({position: 'fixed',top: heightNavMenu});
         } else {
           el.css('position', 'static');
         }

         if ((limit - heightNavMenu) < windowTop) {
           var diff = limit - windowTop;
           el.css({
             top: diff
           });
         }


         //Sidebar Right
         if(heightTotal > heightWindow) {
           if (spaceTop < windowTop) {
             $('.info-pro').css({position: 'fixed',top: -(heightInfo + 20 - heightWindow),width: $('.container-info').width()});
           } else {
             $('.info-pro').css('position', 'static');
           }
           if (limitInfo < windowTop) {
             $('.info-pro').css({position: 'absolute',top: 'auto',bottom: 0});
           }
         } else {
           if ((infoTop-heightNavMenu) < windowTop) {
             $('.info-pro').css({position: 'fixed',top: heightNavMenu+'px',width: $('.container-info').width()});
           } else {
             $('.info-pro').css('position', 'static');
           }
           if ((limit2 - heightNavMenu) < windowTop) {
             var diff = limit2 - windowTop;
             $('.info-pro').css({
               top: diff
             });
           }
         }

         // 2 gallery
         var index = 1;
         $('.images-col-new .image-gallery-product > li').each(function() {
           var offsetBottom = $(this).offset().top + $(this).outerHeight(true) - 90;
           if(($(window).scrollTop() + 200 > ($(this).offset().top) - 90) && (($(window).scrollTop() + 200) < offsetBottom)){
             $(this).addClass('active');
             $('#imageGalleryMini li:nth-child(' + index +')').addClass('active');
           } else {
             $(this).removeClass('active');
             $('#imageGalleryMini li:nth-child(' + index +')').removeClass('active');
           }
           index++;
         });

       });

     var nGallery = 1;
     $('#imageGalleryMini > li').each(function() {
       var element = '.image-gallery-product > li:nth-child(' + nGallery +')';
       $(this).click(function() {
         $('html, body').animate({
           scrollTop: $(element).offset().top - heightNavMenu}, 1000);
       });
       nGallery++;
     });

     $('#imageGalleryMini > li:first-child').addClass('active');
     });
   }
 }/* End slide image product page */

 if ($('#instafeed').length) {
   var userFeed = new Instafeed({
     get: 'user',
     userId: '1417323441',
     accessToken: '1417323441.1677ed0.e34f1660a24949de9ecf5c9afd888816',
     resolution: 'standard_resolution',
     useHttp: "true",
     template: '<div class="col-instagram"><a href="/pages/instagram" target="_blank" id="{{id}}"><div style="background: url({{image}}); background-position: center; padding-top: 100%"></div></a></div>',
     sortBy: 'most-recent',
     limit: 6,
     target: 'instafeed'
   });
   userFeed.run();
 }

 // Instagram for seperate page
 if ($('#instafeedPage').length) {
   var userFeedPage = new Instafeed({
     get: 'user',
     userId: '1417323441',
     accessToken: '1417323441.1677ed0.e34f1660a24949de9ecf5c9afd888816',
     resolution: 'standard_resolution',
     useHttp: "true",
     template: '<div class="col-instagram"><a href="{{link}}" target="_blank" id="{{id}}"><div class="drop"><i class="fa fa-instagram"></i></div><div style="background: url({{image}}); background-position: center; padding-top: 100%;"></div></a></div>',
     sortBy: 'most-recent',
     limit: 6,
     target: 'instafeedPage',
     after: function() {
       // disable button if no more results to load
       if (!this.hasNext()) {
         btnInstafeedLoad.setAttribute('disabled', 'disabled');
       }
     },
   });
   userFeedPage.run();
   var btnInstafeedLoad = document.getElementById("btn-instafeed-load");
   btnInstafeedLoad.addEventListener("click", function() {
     userFeedPage.next();
   });
 }
 // btnInstafeedLoad.click(function() {
 //   userFeedPage.next();
 // });

});

(function($) {

	var tabs =  $(".tabs li a");
  
	tabs.click(function() {
		var content = this.hash.replace('/','');
		tabs.removeClass("active");
		$(this).addClass("active");
    $("#tabcontent").find('div').hide();
    $(content).fadeIn(200);
	});

})(jQuery);